import { useEffect } from 'react';
import reasonListStore from './stores/reason-list-store';
import TranslationScope from '../../translation/translation-scope';
import BasePageLayout from '../../components/layouts/base-page-layout/base-page-layout';
import { Outlet } from 'react-router-dom';


const ReturnReasonsPage: React.FC = () => {

    useEffect(() => {
        reasonListStore.load();
    }, []);

    return (
        <TranslationScope scope="return-reason">
        <BasePageLayout 
            title="Settings" 
            subTitles={['Return Reasons']}
            instruction={<>
                Define return reasons and follow-up questions that customers can choose from in the portal when requesting a return.
            </>}
        >

        <Outlet />

        </BasePageLayout>
        </TranslationScope>
    );
}

export default ReturnReasonsPage;
